// ---------------------------------------------------------------------------
// Step 1 — request the verification mail.
// ---------------------------------------------------------------------------
export const REGISTER_VERIFICATION_EMAIL_ENDPOINT = {
    method: 'POST',
    path: '/api/v1/auth/register/verification-email',
};
// ---------------------------------------------------------------------------
// Step 2 — resolve the mailed link (the SPA route the link points at calls
// this with the URL query it received).
// ---------------------------------------------------------------------------
export const REGISTER_VERIFICATION_ENDPOINT = {
    method: 'GET',
    path: '/api/v1/auth/register/verification',
};
// ---------------------------------------------------------------------------
// Step 2b — stamped skin download (premium only).
// ---------------------------------------------------------------------------
export const REGISTER_STAMPED_SKIN_ENDPOINT = {
    method: 'GET',
    path: '/api/v1/auth/register/stamped-skin',
};
// ---------------------------------------------------------------------------
// Step 2c — stamped skin verification probe (premium only, read-only).
// ---------------------------------------------------------------------------
export const REGISTER_SKIN_CHECK_ENDPOINT = {
    method: 'GET',
    path: '/api/v1/auth/register/skin-check',
};
// ---------------------------------------------------------------------------
// Step 2d — offline username probe (offline branch, read-only).
// ---------------------------------------------------------------------------
export const REGISTER_NAME_CHECK_ENDPOINT = {
    method: 'GET',
    path: '/api/v1/auth/register/name-check',
};
// ---------------------------------------------------------------------------
// Step 3 — submit the registration.
// ---------------------------------------------------------------------------
export const REGISTER_ENDPOINT = {
    method: 'POST',
    path: '/api/v1/auth/register',
};
//# sourceMappingURL=register.js.map